<template>
  <div class="page-container">

    <div v-if="changetype">
      <!-- 搜索栏 - 展商公告 -->
      <div class="page-card">
        <div class="page-card__header">
          <el-row style="width: 100%">
            <el-col :span="2">
              <span>展商公告</span>
            </el-col>
            <el-col :span="22">
              <div style="text-align: right">
                <el-button type="primary" round size="small" @click="go_to_addStationInfo">
                  发布展商公告
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 数据表格 -->
        <el-table :data="tableData" style="width: 100%; padding: 0 20px">
          <el-table-column prop="image" label="封面" width="150">
            <template slot-scope="scope">
              <el-image :src="imgUrl + scope.row.img"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="公告标题"></el-table-column>

          <el-table-column prop="create_time" label="发布时间" width="150">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleClick(scope.row)"
              >详情
              </el-button>
              <el-button
                type="text"
                class="action-btn--danger"
                @click="deleteClick(scope.row)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <div class="pagination-wrap">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            :total="aSum"
            :page-count="pageCount"
            :current-page.sync="currentPage"
            background
            layout="prev, pager, next,jumper"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- 搜索栏 - 反馈信息 -->
      <div class="page-card">
        <div class="page-card__header">
          <span>反馈信息</span>
        </div>

        <!-- 数据表格 -->
        <el-table :data="tableDataHit" style="width: 100%; padding: 0 20px">
          <el-table-column prop="type" label="分类" width="100">
          </el-table-column>
          <el-table-column prop="content" label="反馈内容"></el-table-column>

          <el-table-column prop="tel" label="联系电话" width="120">
          </el-table-column>
          <el-table-column prop="peopleName" label="回复人" width="120">
          </el-table-column>

          <el-table-column prop="date" label="反馈时间" width="150">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleClick(scope.row)"
              >查看详情
              </el-button>
              <el-button type="text">备注</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <div class="pagination-wrap">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            :total="aSum"
            :page-count="pageCount"
            :current-page.sync="currentPage"
            background
            layout="prev, pager, next,jumper"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";
export default {
  data() {
    return {
      // 切换类型标识
      changetype: true,
      // 当前切换ID
      changeID: 0,
      // 新闻图片基础地址
      imgUrl:
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news_banner/",

      // 表格数据
      tableData: [],
      // 总条目数
      aSum: 0,
      // 当前页数
      currentPage: 1,
      // 总页数
      pageCount: 1,
      // 每页显示条目数
      pagesize: 10,
    };
  },
  mounted() {
    // 页面加载时获取展商公告列表
    this.getInfo();
  },
  methods: {
    /**
     * 获取展商公告列表数据
     */
    getInfo() {
      let url = this.baseUrl + "/admin/news/?type=2";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    /**
     * 分页切换处理
     * @param {number} val - 目标页码
     */
    handleCurrentChange(val) {
      let url = this.baseUrl + "/admin/news/?type=2&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    /**
     * 删除展商公告
     * @param {object} row - 当前行数据
     */
    deleteClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/news/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getInfo();
        });
      });
    },

    /**
     * 切换到展商公告视图
     */
    changePage() {
      this.changetype = true;
    },

    /**
     * 切换到反馈信息视图
     */
    changePage_hit() {
      this.changetype = false;
    },

    /**
     * 跳转到添加展商公告页面
     */
    go_to_addStationInfo() {
      this.$router.push({ name: "admin_addStationInfo" });
    },

    /**
     * 跳转到展商公告详情页面
     * @param {object} row - 当前行数据
     */
    handleClick(row) {
      this.$router.push({
        name: "admin_stationInfoDetail",
        query: { id: row.id },
      });
    },
  },
};
</script>

<style scoped>
.changtype {
  background-color: var(--color-primary);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/stationInfoList.vue